module.exports = __webpack_public_path__ + "header_two.f2f2de96e14a40255e93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/header_two.jpg
// module id = 1046
// module chunks = 2